// extracted by mini-css-extract-plugin
export default {"modal":"LoadingModal_modal__+9bVD","Loader":"LoadingModal_Loader__6bzVH"};